module.exports = __webpack_public_path__ + "img/3.1dd0a419.jpg";